import { isValidElement, ReactChild } from 'react';

export function isDefined<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}

export function isValidReactChild(child: any): child is ReactChild & { key: string } {
  return isDefined(child) && isValidElement(child) && 'key' in child;
}
